// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.general-info-container {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  margin-bottom: 2rem;
}

.form-section {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.section-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #f09502;
  margin-bottom: 0.5rem;
}

.section-description {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
}

.form-control {
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  outline: none;
}

.form-control:focus {
  border-color: #f09502;
  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);
}

.form-control.errorInput {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.description-textarea {
  resize: vertical;
  min-height: 100px;
}

.location-section {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.location-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.location-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #f09502;
  margin-bottom: 0.25rem;
}

.location-subtitle {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

.location-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.address-search {
  margin-bottom: 1.5rem;
}

.address-search-input {
  font-size: 1rem;
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: border-color 0.3s ease;
  width: 100%;
}

.address-search-input:focus {
  border-color: #f09502;
  outline: none;
  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);
}

.search-hint {
  margin-top: 0.5rem;
  padding: 0.5rem;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #f09502;
}

.search-hint small {
  color: #6c757d;
  font-style: italic;
}

.api-error-message {
  margin-top: 1rem;
}

.api-error-message .alert {
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #ffc107;
  background: #fff3cd;
  color: #856404;
}

.api-error-message .alert i {
  margin-right: 0.5rem;
  color: #ffc107;
}

.manual-mode-notice {
  margin-top: 1rem;
}

.manual-mode-notice .alert {
  padding: 1rem;
  border-radius: 8px;
  border-left: 4px solid #17a2b8;
  background: #d1ecf1;
  color: #0c5460;
}

.manual-mode-notice .alert i {
  margin-right: 0.5rem;
  color: #17a2b8;
}

/* Estilos para el autocompletado de Google Places */
.pac-container {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  margin-top: 4px;
  z-index: 1000;
  background: white;
}

.pac-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
}

.pac-item:hover {
  background-color: #f8f9fa;
  transform: translateX(2px);
}

.pac-item-selected {
  background-color: #f09502;
  color: white;
  transform: translateX(4px);
}

.pac-item-query {
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}

.pac-item-selected .pac-item-query {
  color: white;
}

.pac-item-query-match {
  font-weight: 500;
  color: #666;
}

.pac-item-selected .pac-item-query-match {
  color: rgba(255, 255, 255, 0.9);
}

.map-container {
  margin-bottom: 1.5rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.generated-iframe {
  margin-bottom: 1.5rem;
}

.iframe-preview {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.address-inputs {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-top: 1rem;
}

.description-section {
  display: flex;
  flex-direction: column;
}

.map-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 3rem;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
}

.map-placeholder:hover {
  border-color: #f09502;
  color: #f09502;
  background: #fff5f0;
}

.map-placeholder i {
  font-size: 2rem;
  margin-bottom: 0.5rem;
}

.map-placeholder span {
  font-size: 1rem;
  font-weight: 500;
}

/* Estilos para las características del inmueble */
.characteristics-section {
  background: transparent;
  border-radius: 8px;
  padding: 1rem 0;
  margin-top: 1.5rem;
}

.characteristics-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
}

.characteristic-card {
  background: transparent;
  border-radius: 12px;
  padding: 0;
  min-width: 100px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80px;
}

.characteristic-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.characteristic-card.selected {
  border-color: #f09502;
  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);
}

.dark-base-box {
  background: #6c757d;
  border-radius: 10px;
  padding: 0.5rem;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.light-inner-box {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 0.5rem 0.75rem;
  width: 90%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.icon-overlay {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.characteristic-icon {
  color: #f09502;
  font-size: 1.2rem;
}

.characteristic-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: #333;
  margin: 0;
  text-align: center;
}

.add-characteristic-btn {
  background: #f09502;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  color: white;
  font-size: 1.2rem;
  margin-left: 0.5rem;
}

.add-characteristic-btn:hover {
  background: #e08502;
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(240, 149, 2, 0.3);
}

.add-characteristic-btn i {
  font-size: 1.2rem;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .address-inputs {
    grid-template-columns: 1fr;
    padding: 1rem;
  }

  .characteristics-grid {
    justify-content: center;
  }

  .characteristic-card {
    min-width: 80px;
    height: 70px;
  }

  .icon-overlay {
    width: 20px;
    height: 20px;
    top: -10px;
  }

  .characteristic-icon {
    font-size: 1rem;
  }

  .dark-base-box {
    padding: 0.4rem;
  }

  .light-inner-box {
    padding: 0.4rem 0.5rem;
  }

  .characteristic-label {
    font-size: 0.65rem;
  }

  .add-characteristic-btn {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
}

/* Estilos para campos deshabilitados */
.form-control:disabled {
  background-color: #f8f9fa;
  opacity: 0.6;
  cursor: not-allowed;
  border-color: #e9ecef;
}

.form-control:disabled::placeholder {
  color: #6c757d;
  font-style: italic;
}

/* Estilos para la sección de descripción */
.description-section {
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.description-header {
  text-align: center;
  margin-bottom: 1.5rem;
}

.description-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #f09502;
  margin-bottom: 0.25rem;
}

.description-subtitle {
  color: #666;
  font-size: 0.9rem;
  margin: 0;
}

.description-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.description-textarea {
  background: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 1rem;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  outline: none;
  resize: vertical;
  min-height: 120px;
  font-family: 'Montserrat', sans-serif;
}

.description-textarea:focus {
  background: #fff;
  border-color: #f09502;
  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);
}

.description-textarea::placeholder {
  color: #6c757d;
  font-style: italic;
}

/* Estilos para la sección de fechas clave y rentabilidad */
.dates-profitability-section {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.sections-row {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.section-block {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.section-header-block {
  background: #f09502;
  padding: 1rem;
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.section-header-title {
  color: white;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0;
  font-family: 'Montserrat', sans-serif;
}

.fields-container {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.field-row {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.field-label-box {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.field-label {
  color: #333;
  font-size: 0.9rem;
  font-weight: 500;
  display: block;
}

.field-input-box {
  flex: 1;
  background: #fff5e6;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.field-input {
  width: 100%;
  border: none;
  background: transparent;
  color: #333;
  font-size: 0.9rem;
  outline: none;
}

.field-input::placeholder {
  color: #666;
  font-style: italic;
}

.field-input:focus {
  background: #fff;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
}

/* Estilos para la fila de número y piso */
.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-row .form-group {
  flex: 1;
  margin-bottom: 0;
}

.form-row .form-group.col-md-6 {
  flex: 0 0 calc(50% - 0.5rem);
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
    gap: 0;
  }
  
  .form-row .form-group.col-md-6 {
    flex: 1;
    margin-bottom: 1rem;
  }

  /* Responsive para fechas clave y rentabilidad */
  .sections-row {
    flex-direction: column;
    gap: 1.5rem;
  }

  .field-row {
    flex-direction: column;
    gap: 0.5rem;
  }

  .field-label-box,
  .field-input-box {
    flex: none;
    width: 100%;
  }
}

/* Estilos para campos dinámicos */
.add-field-btn {
  background: #f09502;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.add-field-btn:hover {
  background: #e08502;
  transform: scale(1.05);
}

.add-field-btn i {
  font-size: 14px;
}

.dynamic-field {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
}

.editable-label {
  background: transparent;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 0.5rem;
  font-size: 0.9rem;
  width: 100%;
  transition: border-color 0.2s ease;
}

.editable-label:focus {
  outline: none;
  border-color: #f09502;
  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.2);
}

.field-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
}

.remove-field-btn {
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.4rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
}

.remove-field-btn:hover {
  background: #c82333;
  transform: scale(1.05);
}

.remove-field-btn i {
  font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/new-project-general-info/new-project-general-info.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,2DAA2D;AAC3D;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,OAAO;IACP,mBAAmB;EACrB;;EAEA,gDAAgD;EAChD;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;AACF;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".general-info-container {\n  background: #fff;\n  border-radius: 12px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n}\n\n.form-section {\n  background: #fff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.section-title {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #f09502;\n  margin-bottom: 0.5rem;\n}\n\n.section-description {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1rem;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-label {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 0.5rem;\n  font-size: 0.9rem;\n}\n\n.form-control {\n  padding: 0.75rem;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.form-control:focus {\n  border-color: #f09502;\n  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);\n}\n\n.form-control.errorInput {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n}\n\n.description-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.location-section {\n  background: #fff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.location-header {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.location-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #f09502;\n  margin-bottom: 0.25rem;\n}\n\n.location-subtitle {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.location-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.address-search {\n  margin-bottom: 1.5rem;\n}\n\n.address-search-input {\n  font-size: 1rem;\n  padding: 0.75rem;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  transition: border-color 0.3s ease;\n  width: 100%;\n}\n\n.address-search-input:focus {\n  border-color: #f09502;\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);\n}\n\n.search-hint {\n  margin-top: 0.5rem;\n  padding: 0.5rem;\n  background: #f8f9fa;\n  border-radius: 4px;\n  border-left: 3px solid #f09502;\n}\n\n.search-hint small {\n  color: #6c757d;\n  font-style: italic;\n}\n\n.api-error-message {\n  margin-top: 1rem;\n}\n\n.api-error-message .alert {\n  padding: 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #ffc107;\n  background: #fff3cd;\n  color: #856404;\n}\n\n.api-error-message .alert i {\n  margin-right: 0.5rem;\n  color: #ffc107;\n}\n\n.manual-mode-notice {\n  margin-top: 1rem;\n}\n\n.manual-mode-notice .alert {\n  padding: 1rem;\n  border-radius: 8px;\n  border-left: 4px solid #17a2b8;\n  background: #d1ecf1;\n  color: #0c5460;\n}\n\n.manual-mode-notice .alert i {\n  margin-right: 0.5rem;\n  color: #17a2b8;\n}\n\n/* Estilos para el autocompletado de Google Places */\n.pac-container {\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  border: 1px solid #e0e0e0;\n  margin-top: 4px;\n  z-index: 1000;\n  background: white;\n}\n\n.pac-item {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.9rem;\n}\n\n.pac-item:hover {\n  background-color: #f8f9fa;\n  transform: translateX(2px);\n}\n\n.pac-item-selected {\n  background-color: #f09502;\n  color: white;\n  transform: translateX(4px);\n}\n\n.pac-item-query {\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 2px;\n}\n\n.pac-item-selected .pac-item-query {\n  color: white;\n}\n\n.pac-item-query-match {\n  font-weight: 500;\n  color: #666;\n}\n\n.pac-item-selected .pac-item-query-match {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.map-container {\n  margin-bottom: 1.5rem;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.generated-iframe {\n  margin-bottom: 1.5rem;\n}\n\n.iframe-preview {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.address-inputs {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 1rem;\n  background: #fff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-top: 1rem;\n}\n\n.description-section {\n  display: flex;\n  flex-direction: column;\n}\n\n.map-placeholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border: 2px dashed #dee2e6;\n  border-radius: 8px;\n  padding: 3rem;\n  color: #6c757d;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.map-placeholder:hover {\n  border-color: #f09502;\n  color: #f09502;\n  background: #fff5f0;\n}\n\n.map-placeholder i {\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n}\n\n.map-placeholder span {\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n/* Estilos para las características del inmueble */\n.characteristics-section {\n  background: transparent;\n  border-radius: 8px;\n  padding: 1rem 0;\n  margin-top: 1.5rem;\n}\n\n.characteristics-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.characteristic-card {\n  background: transparent;\n  border-radius: 12px;\n  padding: 0;\n  min-width: 100px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 80px;\n}\n\n.characteristic-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.characteristic-card.selected {\n  border-color: #f09502;\n  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);\n}\n\n.dark-base-box {\n  background: #6c757d;\n  border-radius: 10px;\n  padding: 0.5rem;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.light-inner-box {\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 0.5rem 0.75rem;\n  width: 90%;\n  height: 80%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.icon-overlay {\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  background: #fff;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.characteristic-icon {\n  color: #f09502;\n  font-size: 1.2rem;\n}\n\n.characteristic-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #333;\n  margin: 0;\n  text-align: center;\n}\n\n.add-characteristic-btn {\n  background: #f09502;\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  border: none;\n  color: white;\n  font-size: 1.2rem;\n  margin-left: 0.5rem;\n}\n\n.add-characteristic-btn:hover {\n  background: #e08502;\n  transform: scale(1.1);\n  box-shadow: 0 4px 12px rgba(240, 149, 2, 0.3);\n}\n\n.add-characteristic-btn i {\n  font-size: 1.2rem;\n}\n\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .address-inputs {\n    grid-template-columns: 1fr;\n    padding: 1rem;\n  }\n\n  .characteristics-grid {\n    justify-content: center;\n  }\n\n  .characteristic-card {\n    min-width: 80px;\n    height: 70px;\n  }\n\n  .icon-overlay {\n    width: 20px;\n    height: 20px;\n    top: -10px;\n  }\n\n  .characteristic-icon {\n    font-size: 1rem;\n  }\n\n  .dark-base-box {\n    padding: 0.4rem;\n  }\n\n  .light-inner-box {\n    padding: 0.4rem 0.5rem;\n  }\n\n  .characteristic-label {\n    font-size: 0.65rem;\n  }\n\n  .add-characteristic-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n}\n\n/* Estilos para campos deshabilitados */\n.form-control:disabled {\n  background-color: #f8f9fa;\n  opacity: 0.6;\n  cursor: not-allowed;\n  border-color: #e9ecef;\n}\n\n.form-control:disabled::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Estilos para la sección de descripción */\n.description-section {\n  background: #fff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.description-header {\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.description-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #f09502;\n  margin-bottom: 0.25rem;\n}\n\n.description-subtitle {\n  color: #666;\n  font-size: 0.9rem;\n  margin: 0;\n}\n\n.description-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.description-textarea {\n  background: #f8f9fa;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  padding: 1rem;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  outline: none;\n  resize: vertical;\n  min-height: 120px;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.description-textarea:focus {\n  background: #fff;\n  border-color: #f09502;\n  box-shadow: 0 0 0 3px rgba(240, 149, 2, 0.1);\n}\n\n.description-textarea::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Estilos para la sección de fechas clave y rentabilidad */\n.dates-profitability-section {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.sections-row {\n  display: flex;\n  gap: 2rem;\n  align-items: flex-start;\n}\n\n.section-block {\n  flex: 1;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.section-header-block {\n  background: #f09502;\n  padding: 1rem;\n  text-align: center;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.section-header-title {\n  color: white;\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n}\n\n.fields-container {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.field-row {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.field-label-box {\n  flex: 1;\n  background: #fff;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n}\n\n.field-label {\n  color: #333;\n  font-size: 0.9rem;\n  font-weight: 500;\n  display: block;\n}\n\n.field-input-box {\n  flex: 1;\n  background: #fff5e6;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e9ecef;\n}\n\n.field-input {\n  width: 100%;\n  border: none;\n  background: transparent;\n  color: #333;\n  font-size: 0.9rem;\n  outline: none;\n}\n\n.field-input::placeholder {\n  color: #666;\n  font-style: italic;\n}\n\n.field-input:focus {\n  background: #fff;\n  border-radius: 4px;\n  padding: 0.25rem 0.5rem;\n}\n\n/* Estilos para la fila de número y piso */\n.form-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.form-row .form-group {\n  flex: 1;\n  margin-bottom: 0;\n}\n\n.form-row .form-group.col-md-6 {\n  flex: 0 0 calc(50% - 0.5rem);\n}\n\n@media (max-width: 768px) {\n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .form-row .form-group.col-md-6 {\n    flex: 1;\n    margin-bottom: 1rem;\n  }\n\n  /* Responsive para fechas clave y rentabilidad */\n  .sections-row {\n    flex-direction: column;\n    gap: 1.5rem;\n  }\n\n  .field-row {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .field-label-box,\n  .field-input-box {\n    flex: none;\n    width: 100%;\n  }\n}\n\n/* Estilos para campos dinámicos */\n.add-field-btn {\n  background: #f09502;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n}\n\n.add-field-btn:hover {\n  background: #e08502;\n  transform: scale(1.05);\n}\n\n.add-field-btn i {\n  font-size: 14px;\n}\n\n.dynamic-field {\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  margin-bottom: 0.5rem;\n  padding: 0.5rem;\n}\n\n.editable-label {\n  background: transparent;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 0.5rem;\n  font-size: 0.9rem;\n  width: 100%;\n  transition: border-color 0.2s ease;\n}\n\n.editable-label:focus {\n  outline: none;\n  border-color: #f09502;\n  box-shadow: 0 0 0 2px rgba(240, 149, 2, 0.2);\n}\n\n.field-actions {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n}\n\n.remove-field-btn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 0.4rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n}\n\n.remove-field-btn:hover {\n  background: #c82333;\n  transform: scale(1.05);\n}\n\n.remove-field-btn i {\n  font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
